import React, { ChangeEvent, FC, useState } from "react";
import { TextField } from "@mui/material";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form/dist/types/controller";

const Reason: FC<
  {
    field: ControllerRenderProps;
    fieldState: ControllerFieldState;
  } & {
    disabled?: boolean;
    hideTitle?: boolean;
    handleChange?: (selected: string) => void;
    title?: string;
    direction?: "row" | "column";
  }
> = ({
  fieldState,
  field,
  disabled,
  hideTitle = false,
  handleChange,
  title = "Reason:",
  direction,
}) => {
  const [value, setValue] = useState(hideTitle ? field.value.trim() : "");
  const [inputVal, setInputVal] = useState("");
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    field.onChange(e?.target?.value.trim());
    setValue(e?.target?.value);
    setInputVal(e?.target?.value);
  };

  const onBlur = () => {
    handleChange?.(value);
  };

  const onKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      onBlur();
    }
  };

  return (
    <>
      <div
        style={{
          marginTop: 8,
          flexBasis: "100%",
          display: "flex",
          alignItems: "start",
          flexDirection: direction ? direction : "column",
        }}
      >
        {hideTitle && (title ?? "").length > 0 ? null : (
          <p
            style={{
              fontSize: 12,
              color: "#535759",
              fontWeight: 500,
              display: "flex",
              marginRight: direction ? 10 : 82,
            }}
          >
            <span style={{ color: "#FF5F58", fontSize: "1rem", marginRight: 4 }}>*</span>
            {title ?? "Reason:"}
          </p>
        )}
        <div
          style={{
            width: "100%",
            position: "relative",
            display: "inline-block",
          }}
        >
          <TextField
            {...field}
            fullWidth={true}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            variant="outlined"
            size="small"
            rows={direction ? 20 : 3}
            multiline
            placeholder={"Please input"}
            disabled={disabled}
            onChange={onChange}
            value={value}
            onBlur={hideTitle ? onBlur : undefined}
            autoFocus={hideTitle}
            onKeyPress={onKeyPress}
            style={{ width: "100%", position: "relative", paddingBottom: 12 }}
          />

          <p
            style={{
              position: "absolute",
              right: 5,
              bottom: 15,
              whiteSpace: "nowrap",
              color: "#535759",
              fontSize: 12,
              translate: "(0, 100%)",
              pointerEvents: "none",
            }}
          >
            {inputVal?.length ?? 0} / {direction ? 1000 : 50}
          </p>
        </div>
      </div>
    </>
  );
};

export default Reason;
